import React from 'react';
import clsx from 'clsx';

/**
 * Title block of a listing page: icon, title, one sentence of description and
 * the page's main action on the right.
 *
 * Lifted from `Sellers.jsx`, whose markup is copied by hand into Couriers,
 * Alianzas, Zonas and Servicios externos. Those admin pages still carry their
 * copies and move to this in a later pass.
 *
 * @param {object} props
 * @param {React.ComponentType} [props.icon]
 * @param {string} [props.iconClassName] - Colours of the icon tile.
 * @param {string} props.title
 * @param {string} [props.description]
 * @param {React.ReactNode} [props.actions] - Usually the one primary button.
 * @param {string} [props.testId='page-header']
 */
export const PageHeader = ({
  icon: Icon,
  iconClassName = 'bg-ninja-greenLight dark:bg-ninja-green/20 text-ninja-green',
  title,
  description,
  actions,
  testId = 'page-header',
}) => (
  <div
    data-testid={testId}
    className="flex flex-col sm:flex-row sm:items-center justify-between gap-4"
  >
    <div className="min-w-0">
      <h1 className="text-2xl font-black text-ninja-dark dark:text-white flex items-center gap-3">
        {Icon && (
          <div className={clsx('w-10 h-10 rounded-xl flex items-center justify-center flex-shrink-0', iconClassName)}>
            <Icon size={20} />
          </div>
        )}
        {title}
      </h1>
      {description && <p className="text-text-secondary mt-1">{description}</p>}
    </div>
    {actions && <div className="flex items-center gap-3 flex-shrink-0">{actions}</div>}
  </div>
);
